export const PROJECT_SEARCH_PARAM_KEY = {
    rightSidebarCollapsed: "rc",
    rightSidebarTab: "rt",
    clarificationView: "crv",
    clarificationSelectedId: "crs",
    sectionFocusTabKey: "est",
    sectionFocusFieldId: "esf",
    sectionFocusNonce: "esi",
    qualityGuardView: "qgv",
    qualityGuardSeverity: "qgs",
    qualityGuardScopeKind: "qgk",
    qualityGuardScopeId: "qgi",
    qualityGuardPanelFocus: "qgp",
    qualityGuardPanelFindingId: "qgf",
    knowledgeSort: "ksr",
    documentsSort: "dsr",
};
export const PROJECT_RIGHT_SIDEBAR_TAB = {
    clarificationRequests: "cr",
    qualityGuardian: "g",
};
export const PROJECT_CLARIFICATION_VIEW = {
    thread: "t",
};
export const PROJECT_QUALITY_GUARD_VIEW = {
    issueDetails: "issues",
};
export const PROJECT_QUALITY_GUARD_SCOPE_KIND = {
    project: "project",
    entity: "entity",
    folder: "folder",
};
export const PROJECT_QUALITY_GUARD_PANEL_FOCUS = {
    critical: "critical",
    high: "high",
    recommended: "recommended",
    accepted: "accepted",
};
/** Query string (no leading `?`) for links built outside the router: Teams DMs, emails. */
export function serializeProjectSearchParams(search) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(search)) {
        if (value !== undefined) {
            params.set(key, String(value));
        }
    }
    return params.toString();
}
export function buildEntityClarificationThreadSearchParams(clarificationRequestId) {
    return {
        [PROJECT_SEARCH_PARAM_KEY.rightSidebarTab]: PROJECT_RIGHT_SIDEBAR_TAB.clarificationRequests,
        [PROJECT_SEARCH_PARAM_KEY.rightSidebarCollapsed]: false,
        [PROJECT_SEARCH_PARAM_KEY.clarificationView]: PROJECT_CLARIFICATION_VIEW.thread,
        [PROJECT_SEARCH_PARAM_KEY.clarificationSelectedId]: clarificationRequestId,
    };
}
export function buildProjectClarificationThreadSearchParams(clarificationRequestId) {
    return {
        [PROJECT_SEARCH_PARAM_KEY.clarificationView]: PROJECT_CLARIFICATION_VIEW.thread,
        [PROJECT_SEARCH_PARAM_KEY.clarificationSelectedId]: clarificationRequestId,
    };
}
export function buildEntitySectionFocusSearchParams(args) {
    return {
        [PROJECT_SEARCH_PARAM_KEY.sectionFocusTabKey]: args.tabKey,
        [PROJECT_SEARCH_PARAM_KEY.sectionFocusFieldId]: args.fieldId,
        [PROJECT_SEARCH_PARAM_KEY.sectionFocusNonce]: args.nonce,
    };
}
export function buildEntityQualityGuardPanelSearchParams(args) {
    const findingId = args.findingId?.trim();
    return {
        [PROJECT_SEARCH_PARAM_KEY.rightSidebarTab]: PROJECT_RIGHT_SIDEBAR_TAB.qualityGuardian,
        [PROJECT_SEARCH_PARAM_KEY.rightSidebarCollapsed]: false,
        [PROJECT_SEARCH_PARAM_KEY.qualityGuardPanelFocus]: args.focus,
        [PROJECT_SEARCH_PARAM_KEY.qualityGuardPanelFindingId]: findingId || undefined,
        [PROJECT_SEARCH_PARAM_KEY.qualityGuardView]: undefined,
        [PROJECT_SEARCH_PARAM_KEY.qualityGuardSeverity]: undefined,
        [PROJECT_SEARCH_PARAM_KEY.qualityGuardScopeKind]: undefined,
        [PROJECT_SEARCH_PARAM_KEY.qualityGuardScopeId]: undefined,
    };
}
